export default "__VITE_ASSET__CrUbfgOD__"